export const PROCESSED_STATUS_COLOR: Record<
  MarketPlaceNoteValidation["processedStatus"],
  string
> = {
  "Call Again": "processing",
  "No Meeting": "default",
  "Not Interested": "error",
  Pending: "warning",
  Failed: "error",
  Success: "success",
};

export const STATUS_COLOR: Record<
  NonNullable<MarketPlaceNoteValidation["status"]>,
  string
> = {
  Success: "success",
  Failed: "error",
  Pending: "warning",
};

export const CLIENT_MOOD_COLOR: Record<
  NoteValidationResponseData["clientMood"],
  string
> = {
  positive: "success",
  neutral: "default",
  negative: "error",
};
export interface NoteValidationResponseData {
  id: string;
  note: string;
  status: string;
  userId: string;
  keywords: string[];
  language: string;
  clientMood: string;
  aiSuggestion: string;
}

export interface MarketPlaceNoteValidation {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  createdBy: string;
  updatedBy: string;
  userId: string;
  rawNote: string;
  processedNote: string | null;
  language: string;
  customerId: string;
  processedStatus: string;
  suggestion: string | null;
  responseData: NoteValidationResponseData | Record<string, never>;
  status: string;
}
